module.exports = __webpack_public_path__ + "img/Kart 2.jpeg";